import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MiTienda } from '../../components/sucursales/mi-tienda/mi-tienda';

@Component({
  selector: 'allas-mi-tienda-page',

  imports: [CommonModule, MiTienda],
  template: `
    <allas-mi-tienda [isMobile]="true" (onClose)="goBack()"> </allas-mi-tienda>
  `,
})
export class MiTiendaPage {
  constructor(private router: Router) {}

  goBack(): void {
    this.router.navigate(['/']);
  }
}
